import React from "react";
import Found from "../../images/Svg/404 page.gif";

const NotFound = () => {
  return (
    <div className="mb-12">
      <img className="mx-auto" src={Found} alt="" />

      <a href="/home">
        {" "}
        <button className="bg-blue p-8 font-normal cursor-pointor text-white  text-center w-[220px] rounded-[52px] h-[50px] flex items-center mx-auto justify-center">
          Go back
        </button>
      </a>
    </div>
  );
};

export default NotFound;
